var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVehicle = function SvgVehicle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "vehicle_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#vehicle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.679 15.417v.785a.85.85 0 0 1-.258.624.85.85 0 0 1-.625.258.85.85 0 0 1-.624-.258.85.85 0 0 1-.256-.624v-5.878q0-.13.017-.26t.057-.248l1.492-4.22q.15-.45.543-.731.393-.282.88-.282h8.189q.487 0 .88.282.393.28.543.731l1.492 4.22q.04.119.057.248.017.13.017.26v5.878a.85.85 0 0 1-.258.624.85.85 0 0 1-.625.258.85.85 0 0 1-.624-.258.85.85 0 0 1-.256-.624v-.785zm-.007-6.603h10.654l-.987-2.812a.26.26 0 0 0-.096-.124.26.26 0 0 0-.152-.045H5.908a.26.26 0 0 0-.152.045.27.27 0 0 0-.096.124zm1.547 4.391q.454 0 .772-.318.315-.318.316-.773 0-.455-.318-.772a1.06 1.06 0 0 0-.774-.316q-.455 0-.77.318-.318.319-.318.774t.319.77.773.317m7.564 0q.454 0 .772-.318.316-.318.316-.773t-.318-.772a1.06 1.06 0 0 0-.773-.316q-.455 0-.772.318-.315.319-.316.774 0 .455.318.77.318.317.773.317m-9.617.962h11.667v-4.103H4.166z"
  }))));
};
export default SvgVehicle;